import { InfoCalloutHtml, NoteCalloutHtml, WarningCalloutHtml } from './tinyCalloutsHtml'
import videoUrlParser from 'js-video-url-parser/dist/jsVideoUrlParser.js'
import * as FileAPI from 'modules/FileAPI'

const YOUTUBE = 'youtube'
const VIMEO = 'vimeo'
const WISTIA = 'wistia'

export const youtubeRegex = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/gm
// eslint-disable-next-line
export const vimeoRegex = /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/
export const wistiaRegex = /(?:(?:medias|iframe)\/|wvideo=)([\w-]+)/

export const validateInput = url => youtubeRegex.test(url) || vimeoRegex.test(url) || wistiaRegex.test(url)

export const buildUrl = url => {
  const info = videoUrlParser.parse(url)
  
  if (info && info.provider === YOUTUBE) {
    return `https://www.youtube.com/embed/${info.id}`
  }
  
  if (info && info.provider === VIMEO) {
    return `https://player.vimeo.com/video/${info.id}`
  }
  
  if (info && info.provider === WISTIA) {
    return `https://fast.wistia.com/embed/iframe/${info.id}`
  }
  
  return url
}

export const addhttps = url => {
  if (!url.startsWith('https')) {
    url.replace(/^.{4}/g, 'https')
  }
  
  return url;
}

const calloutsMenuItems = () => {
  return [
    {
      text: 'Info',
      onclick: () => {
        const editor = window.tinyMCE.activeEditor
        editor.insertContent(InfoCalloutHtml)
      }
    },
    {
      text: 'Note',
      onclick: () => {
        const editor = window.tinyMCE.activeEditor
        editor.insertContent(NoteCalloutHtml)
      }
    },
    {
      text: 'Warning',
      onclick: () => {
        const editor = window.tinyMCE.activeEditor
        editor.insertContent(WarningCalloutHtml)
      }
    }
  ]
}

export const tinyMCESetup = editor => {
  editor.addButton('callouts', {
    type: 'menubutton',
    text: 'Callouts',
    icon: false,
    style: 'max-height: 24px;',
    menu: calloutsMenuItems()
  })
}

export const imageUploadHandler = (file, success, failure) => {
  return FileAPI.upload(file.blob())
    .then(res => success(res.url))
}

export const tinyFilePicker = (cb, value) => {
  const input = document.createElement('input')
  input.setAttribute('type', 'file')
  input.setAttribute('accept', 'image/*')
  input.onchange = function() {
    const file = this.files[0]
    const reader = new FileReader()
    reader.onload = function() {
      const id = `blobid${new Date().getTime()}`
      const blobCache = window.tinymce.activeEditor.editorUpload.blobCache
      const base64 = reader.result.split(',')[1]
      const blobInfo = blobCache.create(id, file, base64)
      blobCache.add(blobInfo)
      cb(blobInfo.blobUri(), { title: file.name })
    }
    reader.readAsDataURL(file)
  }
  input.click()
}

export const mediaURLResolver = (data, resolve, reject) => {
  if (!data.url) return
  
  const url = addhttps(data.url)
  
  if (!validateInput(url)) {
    reject({ msg: 'Sorry, that URL isn\'t supported. Please double check that it\'s a valid Youtube, Vimeo or Wistia link.' });
  }
  
  const link = buildUrl(url);
  
  const embedHTML = `
    <iframe class="embedded-video" title="Video_Uploaded" id="player" type="text/html" src="${link}" width="640" height="476"></iframe>
  `
  
  resolve({ html: embedHTML });
}

export const returnUrlAsRecieved = (url, node, on_save, name) => url